import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

const ALL_SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];

export default function ProductDetail() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedSize, setSelectedSize] = useState(null);
  const [zoomImage, setZoomImage] = useState(null);
  const [showAddedToast, setShowAddedToast] = useState(false);
  const [tryBag, setTryBag] = useState(() => {
    try {
      const saved = localStorage.getItem('fivetryBag');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    try { localStorage.setItem('fivetryBag', JSON.stringify(tryBag)); } catch (e) {}
  }, [tryBag]);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const snap = await getDoc(doc(db, 'products', id));
        if (snap.exists()) setProduct({ id: snap.id, ...snap.data() });
      } catch (e) {
        console.error('Error fetching product:', e);
      }
      setLoading(false);
    };
    fetchProduct();
  }, [id]);

  const isMobile = window.innerWidth < 600;

  const addToTryBag = () => {
    if (!selectedSize) { alert('Please select a size first.'); return; }
    if (tryBag.length >= 5) {
      alert('Your Try Bag is full (5 items). Tap the bag icon to checkout.');
      return;
    }
    setTryBag([...tryBag, { ...product, selectedSize }]);
    setShowAddedToast(true);
    setTimeout(() => setShowAddedToast(false), 2000);
  };

  const NavBar = (
    <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fafaf7', borderBottom: '0.5px solid #eeeae3', display: 'flex', alignItems: 'center', padding: '18px 24px' }}>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
        <span onClick={() => navigate(-1)} style={{ cursor: 'pointer', fontSize: '20px', color: '#1a1a1a', padding: '4px 8px' }}>←</span>
      </div>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
        <h1 onClick={() => navigate('/')} style={{ margin: 0, fontSize: '22px', fontWeight: '500', color: '#1a1a1a', fontFamily: '"Playfair Display", Georgia, serif', letterSpacing: '6px', paddingLeft: '6px', cursor: 'pointer' }}>FIVETRY</h1>
      </div>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <span onClick={() => navigate('/?openTrybag=true')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', position: 'relative', gap: '6px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.15' }}>
            <span style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '2px', color: '#1a1a1a' }}>TRY</span>
            <span style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '2px', color: '#1a1a1a' }}>BAG</span>
          </div>
          <span style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 2 L3 6 V20 a2 2 0 0 0 2 2 H19 a2 2 0 0 0 2-2 V6 L18 2 Z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10 a4 4 0 0 1 -8 0" />
            </svg>
            {tryBag.length > 0 && (
              <span style={{ position: 'absolute', top: '-7px', right: '-9px', background: '#1a1a1a', color: 'white', borderRadius: '50%', width: '16px', height: '16px', fontSize: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600' }}>{tryBag.length}</span>
            )}
          </span>
        </span>
      </div>
    </div>
  );

  if (loading) {
    return (<div style={{ minHeight: '100vh', background: '#fafaf7', fontFamily: 'Arial' }}>{NavBar}<p style={{ textAlign: 'center', color: '#666', padding: '60px 20px' }}>Loading…</p></div>);
  }

  if (!product) {
    return (
      <div style={{ minHeight: '100vh', background: '#fafaf7', fontFamily: 'Arial' }}>
        {NavBar}
        <div style={{ textAlign: 'center', padding: '60px 24px' }}>
          <p style={{ color: '#666', marginBottom: '20px' }}>Product not found.</p>
          <button onClick={() => navigate('/')} style={{ background: '#1a1a1a', color: 'white', border: 'none', padding: '12px 28px', borderRadius: '10px', fontSize: '13px', letterSpacing: '1px', cursor: 'pointer' }}>BACK TO HOME</button>
        </div>
      </div>
    );
  }

  const priceNum = parseFloat(String(product.price).replace(/[₹,]/g, ''));
  const mrpNum = parseFloat(String(product.mrp || '').replace(/[₹,]/g, ''));
  const discount = mrpNum > priceNum ? Math.round(((mrpNum - priceNum) / mrpNum) * 100) : 0;

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf7', fontFamily: 'Arial', paddingBottom: '90px' }}>
      {NavBar}

      <img src={product.image} alt={product.name} onClick={() => setZoomImage(product.image)} style={{ width: '100%', height: isMobile ? '62vh' : '560px', objectFit: 'cover', cursor: 'zoom-in', display: 'block' }} />

      <div style={{ padding: '22px 24px', maxWidth: '700px', margin: '0 auto' }}>
        <h2 style={{ margin: '0 0 10px', fontSize: '20px', color: '#1a1a1a', fontWeight: '600', lineHeight: '1.3' }}>{product.name}</h2>

        {product.description && (
          <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#666', lineHeight: '1.6' }}>{product.description}</p>
        )}

        <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', marginBottom: '22px', flexWrap: 'wrap' }}>
          <span style={{ color: '#111', fontSize: '22px', fontWeight: '700' }}>{product.price}</span>
          {discount > 0 && (
            <>
              <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '15px' }}>{product.mrp}</span>
              <span style={{ color: '#16a34a', fontSize: '13px', fontWeight: '700' }}>{discount}% OFF</span>
            </>
          )}
        </div>

        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '11px', color: '#666', letterSpacing: '1px', marginBottom: '10px', fontWeight: '600', textTransform: 'uppercase' }}>Select Size</div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {Array.isArray(product.sizes) && product.sizes.map((size) => {
              const isSelected = selectedSize === size;
              const soldOut = product.stock && Object.keys(product.stock).length > 0 && (parseInt(product.stock[size], 10) || 0) <= 0;
              return (
                <button key={size} disabled={soldOut} onClick={() => { if (soldOut) return; setSelectedSize(size); }}
                  style={{
                    minWidth: '50px', padding: '10px 14px',
                    background: soldOut ? '#f3f0ea' : (isSelected ? '#1a1a1a' : 'white'),
                    color: soldOut ? '#bbb' : (isSelected ? 'white' : '#1a1a1a'),
                    border: '1px solid ' + (soldOut ? '#e5e0d5' : (isSelected ? '#1a1a1a' : '#d6cdb8')),
                    borderRadius: '8px', fontSize: '14px', fontWeight: '600',
                    cursor: soldOut ? 'not-allowed' : 'pointer', letterSpacing: '0.5px',
                    textDecoration: soldOut ? 'line-through' : 'none',
                  }}>{size}</button>
              );
            })}
          </div>
        </div>

        {product.sizeChart && ALL_SIZES.filter(s => product.sizeChart[s]).length > 0 && (
          <div style={{ background: 'white', border: '1px solid #eeeae3', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' }}>
            <div style={{ fontSize: '10px', letterSpacing: '1px', color: '#9c7d4f', fontWeight: '700', textTransform: 'uppercase', marginBottom: '10px' }}>Size Chart (chest in inches)</div>
            <div style={{ display: 'flex', gap: '4px', overflowX: 'auto' }}>
              {ALL_SIZES.filter(size => product.sizeChart[size]).map((size) => {
                const isSelected = selectedSize === size;
                return (
                  <div key={size} style={{ flex: 1, minWidth: '40px', textAlign: 'center', padding: '8px 4px', background: isSelected ? '#9c7d4f' : 'transparent', borderRadius: '4px', transition: '0.2s' }}>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: isSelected ? 'white' : '#111' }}>{size}</div>
                    <div style={{ fontSize: '13px', color: isSelected ? 'white' : '#666', fontWeight: '500', marginTop: '3px' }}>{product.sizeChart[size]}"</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <div style={{ padding: '4px 24px 36px', maxWidth: '700px', margin: '0 auto' }}>
        <button onClick={addToTryBag} style={{ width: '100%', background: '#111', color: 'white', border: 'none', padding: '16px', borderRadius: '12px', fontSize: '14px', fontWeight: '700', letterSpacing: '1.5px', cursor: 'pointer' }}>
          ADD TO BAG
        </button>
      </div>
      {showAddedToast && (
        <div style={{ position: 'fixed', bottom: '90px', left: '50%', transform: 'translateX(-50%)', background: '#1a1a1a', color: 'white', padding: '14px 24px', borderRadius: '8px', zIndex: 5000, fontSize: '14px', fontWeight: '500', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', letterSpacing: '0.3px' }}>
          Added to Try Bag · {tryBag.length}/5
        </div>
      )}

      {zoomImage && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.94)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <TransformWrapper initialScale={1} minScale={1} maxScale={5} centerOnInit={true} doubleClick={{ mode: 'zoomIn', step: 1 }} wheel={{ step: 0.2 }}>
            <TransformComponent wrapperStyle={{ width: '100vw', height: '100vh' }} contentStyle={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={zoomImage} alt="Zoomed product" style={{ maxWidth: '92vw', maxHeight: '88vh', objectFit: 'contain', borderRadius: '10px' }} />
            </TransformComponent>
          </TransformWrapper>
          <button onClick={() => setZoomImage(null)} style={{ position: 'fixed', top: '20px', right: '20px', width: '46px', height: '46px', borderRadius: '50%', background: 'rgba(255,255,255,0.18)', color: 'white', border: 'none', fontSize: '26px', cursor: 'pointer', lineHeight: '1', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
          <div style={{ position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)', color: 'rgba(255,255,255,0.85)', fontSize: '13px', letterSpacing: '0.5px', background: 'rgba(0,0,0,0.45)', padding: '8px 16px', borderRadius: '20px', whiteSpace: 'nowrap', zIndex: 10000, pointerEvents: 'none' }}>Pinch or scroll to zoom · Drag to move · × to close</div>
        </div>
      )}
    </div>
  );
}